module.exports = __webpack_public_path__ + "static/media/service-2.f881d59f.jpg";